<template>
  <div 
    v-show="(paquete === 2 || paquete === 3 || paquete === 4) && welcomeText"
    ref="bienvenidaRef"
    class="bienvenida-overlay"
  >
    <div ref="contenidoRef" class="overlay-content">
      <!-- Franja superior con ornamento y texto -->
      <div class="franja-superior">
        <img ref="ornamentoArriba" src="@/assets/Elements (64).avif" alt="ornamento" class="ornamento-arriba" />
        <span ref="tituloRef" class="titulo-pase">Apreciable</span>
      </div>
      
      <!-- Nombre del invitado -->
      <div ref="textoRef" class="welcome-text">
        {{ welcomeText }}
      </div>

      <!-- Mensaje de bienvenida -->
      <div ref="mensajeRef" class="mensaje-bienvenida">
        Para nosotros sería un honor contar con tu presencia en este día tan especial donde celebro mis XV.
   <br>   <br>
      </div>

      <!-- Info -->
      <div class="info-container">
        <div v-if="(paquete === 3 || paquete === 4) && numpase" ref="paseRef" class="info-item">
          <i class="fas fa-ticket-alt"></i>
          <span>PASES: {{ numpase }}</span>
        </div>
        <div v-if="paquete === 4 && mesaText" ref="mesaRef" class="info-item">
          <i class="fas fa-circle"></i>
          <span>MESA: {{ mesaText }}</span>
        </div>
      </div>
      <!-- Ornamento inferior -->
    </div>

    <div v-show="showTooltip" ref="tooltipRef" class="tooltip">
      ¡Recuerda confirmar asistencia!
    </div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, computed, onBeforeUnmount } from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import axios from 'axios';
import baseUrl from '@/api';

gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'InvitadoEvento',
  props: {
    idInvitado: Number,
    nombre: String,
    idFestejado: Number
  },
  setup(props) {
    const bienvenidaRef = ref(null);
    const contenidoRef = ref(null);
    const tituloRef = ref(null);
    const textoRef = ref(null);
    const mensajeRef = ref(null);
    const paseRef = ref(null);
    const mesaRef = ref(null);
    const tooltipRef = ref(null);
    const ornamentoArriba = ref(null);
    const ornamentoAbajo = ref(null);

    const welcomeText = ref('');
    const mesaText = ref('');
    const numpase = ref(null);
    const paquete = ref(null);
    const showTooltip = ref(false);
    let tooltipTimeout;

    const isValidIdInvitado = computed(() => !isNaN(props.idInvitado) && props.idInvitado > 0);

    const fetchData = async () => {
      if (isValidIdInvitado.value) {
        try {
          const url = `${baseUrl}/${props.nombre || ''}/${props.idFestejado || ''}/${props.idInvitado}`;
          const response = await axios.get(url);
          welcomeText.value = response.data.nombre_mostrar;
          mesaText.value = response.data.num_mesa;
          numpase.value = response.data.num_pase;
          paquete.value = response.data.paquete;
        } catch (err) {
          console.error('Error al obtener los datos', err);
        }
      }
    };

    const animateElements = () => {
      const tl = gsap.timeline();

      tl.fromTo(ornamentoArriba.value, { rotation: 0 }, {
        rotation: 360,
        duration: 1,
        ease: 'power2.out'
      });

      tl.fromTo(tituloRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1 }, "-=0.5");
      tl.fromTo(textoRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1 }, "-=0.7");
      tl.fromTo(mensajeRef.value, { opacity: 0, y: 30 }, { opacity: 1, y: 0, duration: 1 }, "-=0.7");
      tl.fromTo([paseRef.value, mesaRef.value], { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1 }, "-=0.7");

      tl.fromTo(ornamentoAbajo.value, { rotation: 0 }, {
        rotation: 360,
        duration: 1,
        ease: 'power2.out'
      }, "-=0.8");

      gsap.fromTo(
        tooltipRef.value,
        { opacity: 0, y: -15, scale: 0.9 },
        { opacity: 1, y: 0, scale: 1, duration: 1.5, ease: "elastic.out(1, 0.5)" }
      );
    };

    const resetElements = () => {
      gsap.set([tituloRef.value, textoRef.value, mensajeRef.value, paseRef.value, mesaRef.value], {
        opacity: 0,
        y: 30
      });
      gsap.set([ornamentoArriba.value, ornamentoAbajo.value], {
        rotation: 0
      });
      gsap.set(tooltipRef.value, { opacity: 0 });
    };

    onMounted(async () => {
      await fetchData();
      await nextTick();

      ScrollTrigger.create({
        trigger: bienvenidaRef.value,
        start: 'top 85%',
        onEnter: () => {
          showTooltip.value = true;
          animateElements();
        },
        onLeaveBack: () => {
          showTooltip.value = false;
          resetElements();
        }
      });
    });

    onBeforeUnmount(() => {
      clearTimeout(tooltipTimeout);
    });

    return {
      bienvenidaRef, contenidoRef, tituloRef, textoRef, mensajeRef,
      paseRef, mesaRef, tooltipRef, ornamentoArriba, ornamentoAbajo,
      welcomeText, mesaText, numpase, paquete, showTooltip
    };
  }
};
</script>


<style scoped>
.bienvenida-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #fff;
  
  background-size: cover;
  background-position: center;
  min-height: 50vh;
  background-size: cover;
  perspective: 1000px;
  padding: 10px 10px;
}

.overlay-content {
  padding: 30px;
  border-radius: 15px;
  text-align: center;
  width: 450px;
  transform-style: preserve-3d;
  transition: transform 0.3s ease;
  position: relative;
}

.titulo-pase {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  font-size: 29px !important;
   color: #e1b4b9;
  ;  font-size: 43px;
  display: block;
  margin-top: 15px;
}

.welcome-text {
  font-size: 1.4rem;
  font-family: 'quote', serif; /* o tu fuente real 'fa' si está bien definida */
  color: #1a1a1a;
  margin-top: 10px;
  margin-bottom: 5px;
  letter-spacing: 0px; /* 👈 elimina el espaciado extra */
  margin: 15px 0 10px;
}

.mensaje-bienvenida {
  font-size: 1rem;
  font-family: 'padres';
  color: #050505;
  margin-top: 10px;
}

.info-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 15px;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: #171717;
  font-family: 'padres';
}

.info-item i {
  margin-right: 8px;
  font-size: 1.2rem;
}

.tooltip {
  position: absolute;
  bottom: 0px;
  background: #f0c9d3;
  color: white;
  padding: 0px 15px;
  border-radius: 8px;
  font-size: 14px;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.ornamento-arriba,
.ornamento-abajo {
  position: absolute;
  width: 30%;
  height: auto;
  right: -50px;               /* ✅ alineado a la derecha */
  top: 0;                 /* o ajusta según quieras: top / bottom */
  transform: translateY(-20%); /* puedes ajustar visualmente */
  opacity: 0.9;
  z-index: 0;
}


</style>